var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIconTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14C3.5 19.1917 7.29167 23.5083 12.25 24.3833L12.3085 24.3365C12.289 24.3327 12.2695 24.3289 12.25 24.325V16.9167H9.625V14H12.25V11.6667C12.25 9.04167 13.9417 7.58333 16.3333 7.58333C17.0917 7.58333 17.9083 7.7 18.6667 7.81667V10.5H17.325C16.0417 10.5 15.75 11.1417 15.75 11.9583V14H18.55L18.0833 16.9167H15.75V24.325C15.7305 24.3289 15.711 24.3327 15.6915 24.3365L15.75 24.3833C20.7083 23.5083 24.5 19.1917 24.5 14C24.5 8.225 19.775 3.5 14 3.5C8.225 3.5 3.5 8.225 3.5 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconTransparent);
export default __webpack_public_path__ + "static/media/FacebookIconTransparent.1c0d11d011d491ba0943b1cd47cf8db8.svg";
export { ForwardRef as ReactComponent };